<template>
  <div v-show="isLoaded" class="dMixologiaGold-container" v-observe-visibility="startAnimate">
    <h2 class="dSection-title" :class="{animate: animate}">
      Mixología
    </h2>
    <h2 class="dSection-subtitle" :class="{animate: animate}">
      vuélvete mixólogo con strongbow y agrega un toque de ingredientes naturales para crear una experiencia nueva de sabor.
    </h2>
    <div class="dSection-videos">
      <div class="dLeft-col">
        <div id="videoGold1" class="video-left"></div>
        <h3>GOLDENBOW</h3>
        <h4>Fresca combinación de sabores exóticos ácidos acentuados con la fusión de cáscara de limón eureka, extracto de yuzu y un acento de menta fresca.</h4>
      </div>
      <div class="dRight-col">
        <div id="videoGold2" class="video-right"></div>
        <h5>BLACKBOW</h5>
        <h6>Doble textura de naranja en tándem con la flor de azahar y cáscara de valencia, contrastando con una intensa sombra negra de carbón activado.</h6>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Bowser from "bowser";
import YouTubePlayer from 'youtube-player';
import tagFunctions from "@/utils/tagFunctions.js";

let timer, percent = 0, quartileTime

export default {
  name: "D_MixologiaGold",
  components: {},
  data() {
    return {
      video1: null,
      video2: null,
      animate: false,
      isSafari: false,
    };
  },
  computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible) {
      if(isVisible) {
        this.animate=true
      }
    },
    record(event) {
      let currentTime = Math.round(event.target.getCurrentTime());
      percent = getPercent(event);
      if (currentTime == quartileTime) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "25"
        );
      }
      if (currentTime == 2 * quartileTime) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "50"
        );
      }
      if (currentTime == 3 * quartileTime) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "75"
        );
      }
      if (currentTime == Math.round(event.target.getDuration() * 0.99)) {
        tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "100"
        );
      }
      function getPercent(event) {
        return Math.round(
          (event.target.getCurrentTime() / event.target.getDuration()) * 100
        );
      }
    },
    onPlayerStateChange(event) {
      quartileTime = Math.round(event.target.getDuration() / 4);
      const getQuartile = () => {
        if (percent <= 25) return 25;
        else if (percent > 25 && percent <= 50) return 50;
        else if (percent > 50 && percent <= 75) return 75;
        else return 100;
      };
      if (event.data == window.YT.PlayerState.PLAYING) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Play", getQuartile())
        timer = setInterval(() => {
          this.record(event);
        }, 1000);
      } else {
        clearInterval(timer);
      }
      if (event.data == window.YT.PlayerState.ENDED) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Complete", getQuartile())  
      }
      if (event.data == window.YT.PlayerState.PAUSED) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Pause", getQuartile())
      }
    },
  },
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  },
  mounted() {
    this.video1 = YouTubePlayer('videoGold1', {videoId: '-rdgMQNYJV4', width: '560', height: '315'})
    this.video1.on('stateChange', this.onPlayerStateChange)
    this.video2 = YouTubePlayer('videoGold2', {videoId: 'xrQL26NGI68', width: '560', height: '315'})
    this.video2.on('stateChange', this.onPlayerStateChange)
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/GoldApple/D_MixologiaGold.scss";
</style>
